import apiClient from './apiClient';

const telephonyService = {
  async connectCall({ phone, phoneNumberId, contactHashId, quoteHashId, saleHashId, returnHashId }) {
    const body = {};
    if (phoneNumberId) body.phone_number_id = phoneNumberId;
    if (phone) body.phone = phone;
    if (contactHashId) body.contact_hash_id = contactHashId;
    if (quoteHashId) body.quote_hash_id = quoteHashId;
    if (saleHashId) body.sale_hash_id = saleHashId;
    if (returnHashId) body.return_hash_id = returnHashId;
    return apiClient.post('/integrations/telephony/clickphone/connect', body);
  },
  async listCalls({
    contactHashId,
    quoteHashId,
    saleHashId,
    returnHashId,
    direction,
    limit,
    offset,
    countOnly,
  } = {}) {
    const params = {};
    if (contactHashId) params.contact_id = contactHashId;
    if (quoteHashId) params.quote_id = quoteHashId;
    if (saleHashId) params.sale_id = saleHashId;
    if (returnHashId) params.return_id = returnHashId;
    if (direction) params.direction = direction;
    if (typeof limit === 'number') params.limit = limit;
    if (typeof offset === 'number') params.offset = offset;
    if (countOnly) params.count_only = true;
    return apiClient.get('/integrations/telephony/clickphone/calls', { params });
  },
  async fetchRecordingBlob(callId) {
    const response = await apiClient.get(`/integrations/telephony/clickphone/calls/${callId}/recording`, {
      responseType: 'blob',
    });
    return new Blob([response], { type: 'audio/mpeg' });
  },
  async downloadRecording(callId) {
    const blob = await telephonyService.fetchRecordingBlob(callId);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `recording_${callId}.mp3`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};

export default telephonyService;


